import {
  Router,
  Smartphone,
  Monitor,
  Server,
  Printer,
  Tv,
  Cpu,
  Camera,
  Gamepad2,
  MonitorPlay,
  HelpCircle,
} from "lucide-react";

export const TYPE_META = {
  router: { label: "נתב", icon: Router, color: "#0055FF" },
  phone: { label: "טלפון", icon: Smartphone, color: "#10B981" },
  computer: { label: "מחשב", icon: Monitor, color: "#6366F1" },
  server: { label: "שרת", icon: Server, color: "#8B5CF6" },
  media: { label: "שרת מדיה", icon: MonitorPlay, color: "#0EA5E9" },
  printer: { label: "מדפסת", icon: Printer, color: "#F59E0B" },
  tv: { label: "טלוויזיה", icon: Tv, color: "#EC4899" },
  camera: { label: "מצלמה", icon: Camera, color: "#EF4444" },
  console: { label: "קונסולה", icon: Gamepad2, color: "#7C3AED" },
  iot: { label: "מכשיר חכם", icon: Cpu, color: "#14B8A6" },
  unknown: { label: "לא ידוע", icon: HelpCircle, color: "#94A3B8" },
};

export function metaFor(type) {
  return TYPE_META[type] || TYPE_META.unknown;
}
